import React, { useState } from "react";
import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "650px",
    borderRadius: "15px",
    padding: "0",
    border: "none",
    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
    overflow: "hidden",
    fontFamily: "'Inter', sans-serif",
  },
  overlay: { backgroundColor: "rgba(0, 0, 0, 0.4)", zIndex: 1009 },
};

const modalHeaderStyle = {
  padding: "20px 25px 0 25px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};
const titleContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  marginBottom: "24px",
  paddingBottom: "24px",
  borderBottom: "1px solid #e2e8f0",
};
const formSectionStyle = {
  padding: "25px",
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  maxHeight: "70vh",
  overflowY: "auto",
};
const inputGroupStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "6px",
};
const labelStyle = { fontSize: "13px", fontWeight: "500", color: "#64748b" };
const toggleContainerStyle = { display: "flex", gap: "8px", width: "100%" };
const footerStyle = {
  padding: "20px 25px",
  backgroundColor: "#fff",
  borderTop: "1px solid #f1f5f9",
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "15px",
  justifyContent: "center",
};

const inputStyle = (isFocused) => ({
  padding: "10px 12px",
  borderRadius: "8px",
  border: isFocused ? "1px solid #3B82F6" : "1px solid #e2e8f0",
  fontSize: "14px",
  fontFamily: "inherit",
  outline: "none",
  backgroundColor: "#ffffff",
  transition:
    "border 0.2s ease-in-out, box-shadow 0.2s ease-in-out, background-color 99999s",
  boxShadow: isFocused ? "0 0 0 1px #3B82F6" : "none",
  WebkitBoxShadow: "0 0 0px 1000px white inset !important",
  WebkitTextFillColor: "#111827 !important",
});

const toggleButtonStyle = (isActive, isHovered) => ({
  flex: 1,
  padding: "8px 16px",
  borderRadius: "8px",
  fontSize: "14px",
  transition: "all 0.2s ease",
  cursor: "pointer",
  border: "1px solid transparent",
  backgroundColor: isActive
    ? isHovered
      ? "#2563EB"
      : "#3B82F6"
    : isHovered
    ? "#e2e8f0"
    : "#f3f4f6",
  color: isActive ? "#ffffff" : "#4b5563",
  fontWeight: isActive ? "600" : "400",
});

const cancelModalButtonStyle = (isHovered) => ({
  backgroundColor: isHovered ? "#e2e8f0" : "#f1f5f9",
  border: "1px solid #e2e8f0",
  borderRadius: "10px",
  padding: "12px",
  cursor: "pointer",
  fontSize: "14px",
  color: "#475569",
  fontWeight: "500",
  textAlign: "center",
  transition: "all 0.2s ease",
});

const saveModalButtonStyle = (isHovered) => ({
  backgroundColor: isHovered ? "#2563EB" : "#3B82F6",
  color: "#fff",
  border: "none",
  borderRadius: "10px",
  padding: "12px",
  fontWeight: "500",
  cursor: "pointer",
  fontSize: "14px",
  textAlign: "center",
  transition: "all 0.2s ease",
});

const primaryButtonStyle = {
  backgroundColor: "#3B82F6",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  padding: "10px 18px",
  fontWeight: "500",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

const ContactFormModal = ({
  isOpen,
  onClose,
  formData,
  setFormData,
  handleSubmit,
  handleAutoAsignar,
  isEditing,
  hideTypeSelector = false,
  defaultType = "Cliente",
}) => {
  const [activeField, setActiveField] = useState(null);
  const [isHoverCancel, setIsHoverCancel] = useState(false);
  const [isHoverSave, setIsHoverSave] = useState(false);
  const [isHoverBtnCliente, setIsHoverBtnCliente] = useState(false);
  const [isHoverBtnProveedor, setIsHoverBtnProveedor] = useState(false);

  const currentTipo = formData.tipo || defaultType;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      ariaHideApp={false}
    >
      <div style={modalHeaderStyle}>
        <div style={titleContainerStyle}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "300",
              color: "#111827",
              margin: 0,
            }}
          >
            {isEditing ? `Editar ${currentTipo}` : `Agregar ${currentTipo}`}
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#6b7280",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit} autoComplete="off">
        <div style={{ ...formSectionStyle, paddingTop: "0" }}>
          {!hideTypeSelector && (
            <div style={inputGroupStyle}>
              <span style={labelStyle}>Tipo</span>
              <div style={toggleContainerStyle}>
                <button
                  type="button"
                  style={toggleButtonStyle(
                    currentTipo === "Cliente",
                    isHoverBtnCliente
                  )}
                  onMouseEnter={() => setIsHoverBtnCliente(true)}
                  onMouseLeave={() => setIsHoverBtnCliente(false)}
                  onClick={() =>
                    !isEditing && setFormData({ ...formData, tipo: "Cliente" })
                  }
                >
                  Cliente
                </button>
                <button
                  type="button"
                  style={toggleButtonStyle(
                    currentTipo === "Proveedor",
                    isHoverBtnProveedor
                  )}
                  onMouseEnter={() => setIsHoverBtnProveedor(true)}
                  onMouseLeave={() => setIsHoverBtnProveedor(false)}
                  onClick={() =>
                    !isEditing &&
                    setFormData({ ...formData, tipo: "Proveedor" })
                  }
                >
                  Proveedor
                </button>
              </div>
            </div>
          )}

          <div style={inputGroupStyle}>
            <span style={labelStyle}>Número de Registro</span>
            <div style={{ display: "flex", gap: "8px" }}>
              <input
                style={{
                  ...inputStyle(activeField === "numeroRegistro"),
                  flexGrow: 1,
                }}
                placeholder={
                  currentTipo === "Cliente" ? "Ej: C-0001" : "Ej: P-0001"
                }
                name="numeroRegistro"
                value={formData.numeroRegistro || ""}
                onChange={handleChange}
                onFocus={() => setActiveField("numeroRegistro")}
                onBlur={() => setActiveField(null)}
              />
              <button
                type="button"
                onClick={handleAutoAsignar}
                style={{
                  ...primaryButtonStyle,
                  padding: "0 15px",
                  fontSize: "13px",
                  whiteSpace: "nowrap",
                }}
              >
                <i className="bi bi-hash" /> Auto-asignar
              </button>
            </div>
          </div>

          <div style={inputGroupStyle}>
            <span style={labelStyle}>Razón Social</span>
            <input
              style={inputStyle(activeField === "empresa")}
              placeholder="Ej: Empresa S.A. de C.V."
              name="empresa"
              value={formData.empresa || ""}
              onChange={handleChange}
              onFocus={() => setActiveField("empresa")}
              onBlur={() => setActiveField(null)}
            />
          </div>

          <div style={inputGroupStyle}>
            <span style={labelStyle}>RFC</span>
            <input
              style={inputStyle(activeField === "rfc")}
              placeholder="Ej: ABC123456789"
              name="rfc"
              value={formData.rfc || ""}
              onChange={handleChange}
              onFocus={() => setActiveField("rfc")}
              onBlur={() => setActiveField(null)}
            />
          </div>

          <div style={inputGroupStyle}>
            <span style={labelStyle}>Contacto</span>
            <input
              style={inputStyle(activeField === "contactoPersonal")}
              placeholder="Ej: Juan Pérez"
              name="contactoPersonal"
              value={formData.contactoPersonal || ""}
              onChange={handleChange}
              onFocus={() => setActiveField("contactoPersonal")}
              onBlur={() => setActiveField(null)}
            />
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "15px",
            }}
          >
            <div style={inputGroupStyle}>
              <span style={labelStyle}>Teléfono</span>
              <input
                style={inputStyle(activeField === "telefono")}
                placeholder="Ej: +52 (55) 1234-5678"
                name="telefono"
                value={formData.telefono || ""}
                onChange={handleChange}
                onFocus={() => setActiveField("telefono")}
                onBlur={() => setActiveField(null)}
              />
            </div>
            <div style={inputGroupStyle}>
              <span style={labelStyle}>Correo Electrónico</span>
              <input
                style={inputStyle(activeField === "correo")}
                placeholder="Ej: contacto@empresa.com"
                name="correo"
                value={formData.correo || ""}
                onChange={handleChange}
                onFocus={() => setActiveField("correo")}
                onBlur={() => setActiveField(null)}
              />
            </div>
          </div>

          <div style={inputGroupStyle}>
            <span style={labelStyle}>Domicilio</span>
            <textarea
              style={{
                ...inputStyle(activeField === "domicilio"),
                minHeight: "80px",
                resize: "none",
              }}
              placeholder="Ej: Calle Principal #123, Col. Centro"
              name="domicilio"
              value={formData.domicilio || ""}
              onChange={handleChange}
              onFocus={() => setActiveField("domicilio")}
              onBlur={() => setActiveField(null)}
            />
          </div>
        </div>

        <div style={footerStyle}>
          <button
            type="button"
            style={cancelModalButtonStyle(isHoverCancel)}
            onClick={onClose}
            onMouseEnter={() => setIsHoverCancel(true)}
            onMouseLeave={() => setIsHoverCancel(false)}
          >
            Cancelar
          </button>
          <button
            type="submit"
            style={saveModalButtonStyle(isHoverSave)}
            onMouseEnter={() => setIsHoverSave(true)}
            onMouseLeave={() => setIsHoverSave(false)}
          >
            {isEditing ? "Guardar cambios" : "Guardar"}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ContactFormModal;
